import CIcon from "@coreui/icons-react";
import {
  CCard,
  CCardBody,
  CCardGroup,
  CCardHeader,
  CCol,
  CContainer,
  CRow,
} from "@coreui/react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { ButtonGhost } from "src/components";
import SignupForm from "src/components/SignupForm/SignupForm";
import styled from "styled-components";

import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const SignupPage = () => {
  const { t } = useTranslation();
  const history = useHistory();

  let query = useQuery();

  let track = query.get("track");

  console.log("track", track);

  // const onSignup = async (orgData) => {
  //   const { email, password } = orgData;
  //   await signInWithEmailAndPassword(auth, email, password);
  //   history.push("/survey/account/onboarding");
  // };

  return (
    <div className="c-app c-default-layout flex-row align-items-center">
      <StyledContainer className="my-3">
        <CRow className="justify-content-center">
          <CCol md="8">
            <CCardGroup>
              <CCard className="p-4 position-relative">
                <CCardHeader>
                  <h1 className="">{t("signup.title", "Sign up")}</h1>
                  <Link className="text-info " to="/survey">
                    Already have an account? Login here
                  </Link>
                </CCardHeader>
                <CCardBody>
                  <SignupForm track={track} />
                </CCardBody>
                <ButtonGhost
                  className="align-self-start d-flex align-items-center summary-btn coreData-intro-back-button"
                  onClick={() => {
                    history.push("/");
                  }}
                >
                  <CIcon name="cil-arrow-left" />
                  <span className="ml-2" style={{ fontSize: "14px" }}>
                    Back
                  </span>
                </ButtonGhost>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </StyledContainer>
    </div>
  );
};

const StyledContainer = styled(CContainer)`
  h4,
  h5 {
    line-height: 1.5 !important;
  }
`;

export default SignupPage;
